var _defs, _g, _path, _path2, _g2, _g3, _g4, _g5, _path3, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _path4, _g15, _path5, _g16, _g17, _g18, _g19, _g20, _path6, _g21, _g22, _path7, _path8, _path9, _g23, _path10, _g24, _g25, _g26, _g27, _path11, _path12, _path13, _g28, _g29, _path14, _path15, _path16, _g30, _path17, _g31, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "242 56 547.898 536.781",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 587.824219 387.605469 L 775.574219 387.605469 L 775.574219 470.273438 L 587.824219 470.273438 Z M 587.824219 387.605469"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 443.229,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 310.813,
    x2: 288.943,
    gradientUnits: "userSpaceOnUse",
    y2: 310.813,
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF7FB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6FB",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5FB",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F4FA",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F3FA",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F2F9",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F1F9",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F1F9",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F0F8",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EFF8",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EEF7",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EDF7",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4ECF7",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3EBF6",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2EAF6",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2E9F5",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E8F5",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 301 373 L 790 373 L 790 485 L 301 485 Z M 301 373"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 780.902344 394.21875 C 781.492188 394.21875 782.078125 394.160156 782.65625 394.046875 C 783.234375 393.929688 783.796875 393.761719 784.34375 393.535156 C 784.890625 393.308594 785.410156 393.03125 785.898438 392.703125 C 786.390625 392.375 786.847656 392 787.265625 391.582031 C 787.683594 391.164062 788.054688 390.710938 788.382812 390.21875 C 788.710938 389.726562 788.988281 389.207031 789.214844 388.664062 C 789.441406 388.117188 789.609375 387.554688 789.726562 386.972656 C 789.839844 386.394531 789.898438 385.808594 789.898438 385.21875 L 789.898438 373.9375 L 328.566406 373.9375 C 327.679688 373.9375 326.800781 373.980469 325.917969 374.066406 C 325.039062 374.15625 324.164062 374.285156 323.300781 374.457031 C 322.433594 374.628906 321.574219 374.84375 320.730469 375.101562 C 319.882812 375.359375 319.050781 375.65625 318.234375 375.992188 C 317.417969 376.332031 316.621094 376.710938 315.839844 377.125 C 315.058594 377.542969 314.304688 377.996094 313.566406 378.488281 C 312.832031 378.980469 312.125 379.507812 311.441406 380.066406 C 310.757812 380.628906 310.101562 381.222656 309.476562 381.847656 C 308.851562 382.472656 308.257812 383.128906 307.699219 383.8125 C 307.136719 384.496094 306.609375 385.203125 306.121094 385.941406 C 305.628906 386.675781 305.175781 387.433594 304.757812 388.210938 C 304.339844 388.992188 303.964844 389.792969 303.625 390.609375 C 303.285156 391.425781 302.988281 392.257812 302.734375 393.105469 C 302.476562 393.949219 302.261719 394.808594 302.089844 395.675781 C 301.917969 396.542969 301.789062 397.414062 301.699219 398.296875 C 301.613281 399.175781 301.570312 400.058594 301.570312 400.941406 L 301.570312 457.15625 C 301.570312 458.042969 301.613281 458.921875 301.699219 459.804688 C 301.789062 460.683594 301.917969 461.558594 302.089844 462.425781 C 302.261719 463.292969 302.476562 464.148438 302.734375 464.996094 C 302.988281 465.84375 303.285156 466.675781 303.625 467.492188 C 303.964844 468.308594 304.339844 469.105469 304.757812 469.886719 C 305.175781 470.667969 305.628906 471.425781 306.121094 472.160156 C 306.609375 472.894531 307.136719 473.605469 307.699219 474.289062 C 308.257812 474.972656 308.851562 475.625 309.476562 476.253906 C 310.101562 476.878906 310.757812 477.472656 311.441406 478.03125 C 312.125 478.59375 312.832031 479.121094 313.566406 479.609375 C 314.304688 480.101562 315.058594 480.554688 315.839844 480.972656 C 316.621094 481.390625 317.417969 481.769531 318.234375 482.105469 C 319.050781 482.445312 319.882812 482.742188 320.730469 483 C 321.574219 483.253906 322.433594 483.46875 323.300781 483.644531 C 324.164062 483.816406 325.039062 483.945312 325.917969 484.03125 C 326.800781 484.117188 327.679688 484.160156 328.566406 484.160156 L 789.898438 484.160156 L 789.898438 472.882812 C 789.898438 472.292969 789.839844 471.707031 789.726562 471.125 C 789.609375 470.546875 789.441406 469.984375 789.214844 469.4375 C 788.988281 468.890625 788.710938 468.371094 788.382812 467.882812 C 788.054688 467.390625 787.683594 466.933594 787.265625 466.515625 C 786.847656 466.097656 786.390625 465.726562 785.898438 465.398438 C 785.410156 465.070312 784.890625 464.792969 784.34375 464.566406 C 783.800781 464.339844 783.234375 464.167969 782.65625 464.054688 C 782.078125 463.9375 781.492188 463.878906 780.902344 463.878906 L 607.402344 463.878906 C 606.808594 463.878906 606.226562 463.824219 605.644531 463.707031 C 605.066406 463.59375 604.503906 463.421875 603.957031 463.195312 C 603.410156 462.96875 602.894531 462.691406 602.402344 462.363281 C 601.910156 462.035156 601.457031 461.660156 601.039062 461.242188 C 600.621094 460.824219 600.246094 460.371094 599.917969 459.878906 C 599.589844 459.386719 599.3125 458.871094 599.085938 458.324219 C 598.863281 457.777344 598.691406 457.214844 598.574219 456.636719 C 598.460938 456.054688 598.402344 455.46875 598.402344 454.878906 L 598.402344 403.222656 C 598.402344 402.628906 598.460938 402.042969 598.574219 401.464844 C 598.691406 400.886719 598.863281 400.320312 599.085938 399.777344 C 599.3125 399.230469 599.589844 398.710938 599.917969 398.21875 C 600.246094 397.726562 600.621094 397.273438 601.039062 396.855469 C 601.457031 396.4375 601.910156 396.066406 602.402344 395.734375 C 602.894531 395.40625 603.410156 395.128906 603.957031 394.90625 C 604.503906 394.679688 605.066406 394.507812 605.644531 394.390625 C 606.226562 394.277344 606.808594 394.21875 607.402344 394.21875 Z M 780.902344 394.21875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 300.515625 496.296875 L 488.265625 496.296875 L 488.265625 578.964844 L 300.515625 578.964844 Z M 300.515625 496.296875"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 52.843,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 400.096,
    x2: 207.129,
    gradientUnits: "userSpaceOnUse",
    y2: 400.096,
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFDFE",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFCFE",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFBFD",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFBFD",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFAFD",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF9FC",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF8FC",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF8FC",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF7FB",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6FB",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5FB",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F4FA",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4FA",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F3FA",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F2F9",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F1F9",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F1F9",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F0F8",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EFF8",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EEF8",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EDF7",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EDF7",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3ECF7",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3EBF6",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3EAF6",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2EAF6",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2E9F5",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E8F5",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E7F5",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0E6F4",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 286 482 L 775 482 L 775 592.78125 L 286 592.78125 Z M 286 482"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 295.191406 502.910156 C 294.597656 502.910156 294.011719 502.851562 293.433594 502.734375 C 292.855469 502.621094 292.292969 502.449219 291.746094 502.222656 C 291.199219 501.996094 290.679688 501.71875 290.191406 501.390625 C 289.699219 501.0625 289.246094 500.691406 288.828125 500.273438 C 288.410156 499.855469 288.035156 499.398438 287.707031 498.910156 C 287.378906 498.417969 287.101562 497.898438 286.875 497.351562 C 286.648438 496.804688 286.480469 496.242188 286.363281 495.664062 C 286.25 495.082031 286.191406 494.5 286.191406 493.90625 L 286.191406 482.628906 L 747.523438 482.628906 C 748.410156 482.628906 749.292969 482.671875 750.171875 482.757812 C 751.050781 482.84375 751.925781 482.972656 752.792969 483.148438 C 753.660156 483.320312 754.515625 483.535156 755.363281 483.789062 C 756.207031 484.046875 757.039062 484.34375 757.855469 484.683594 C 758.671875 485.023438 759.472656 485.398438 760.25 485.816406 C 761.03125 486.234375 761.789062 486.6875 762.523438 487.179688 C 763.257812 487.671875 763.96875 488.195312 764.652344 488.757812 C 765.335938 489.320312 765.988281 489.910156 766.613281 490.539062 C 767.238281 491.164062 767.832031 491.816406 768.390625 492.5 C 768.953125 493.183594 769.480469 493.894531 769.96875 494.628906 C 770.460938 495.363281 770.914062 496.121094 771.332031 496.902344 C 771.75 497.683594 772.125 498.480469 772.464844 499.296875 C 772.804688 500.117188 773.101562 500.949219 773.359375 501.792969 C 773.613281 502.640625 773.828125 503.496094 774 504.363281 C 774.175781 505.230469 774.304688 506.105469 774.390625 506.984375 C 774.476562 507.867188 774.519531 508.75 774.519531 509.632812 L 774.519531 565.847656 C 774.519531 566.730469 774.476562 567.613281 774.390625 568.492188 C 774.304688 569.375 774.175781 570.246094 774 571.117188 C 773.828125 571.984375 773.613281 572.839844 773.359375 573.6875 C 773.101562 574.53125 772.804688 575.363281 772.464844 576.179688 C 772.125 577 771.75 577.796875 771.332031 578.578125 C 770.914062 579.355469 770.460938 580.113281 769.96875 580.851562 C 769.480469 581.585938 768.953125 582.292969 768.390625 582.980469 C 767.832031 583.664062 767.238281 584.316406 766.613281 584.941406 C 765.988281 585.566406 765.335938 586.160156 764.652344 586.722656 C 763.96875 587.28125 763.257812 587.808594 762.523438 588.300781 C 761.789062 588.792969 761.03125 589.246094 760.25 589.664062 C 759.472656 590.078125 758.671875 590.457031 757.855469 590.796875 C 757.039062 591.132812 756.207031 591.433594 755.363281 591.6875 C 754.515625 591.945312 753.660156 592.160156 752.792969 592.332031 C 751.925781 592.503906 751.050781 592.636719 750.171875 592.722656 C 749.292969 592.808594 748.410156 592.851562 747.523438 592.851562 L 286.191406 592.851562 L 286.191406 581.570312 C 286.191406 580.980469 286.25 580.394531 286.363281 579.816406 C 286.480469 579.234375 286.648438 578.671875 286.875 578.128906 C 287.101562 577.582031 287.378906 577.0625 287.707031 576.570312 C 288.035156 576.078125 288.410156 575.625 288.828125 575.207031 C 289.246094 574.789062 289.699219 574.414062 290.191406 574.085938 C 290.679688 573.757812 291.199219 573.480469 291.746094 573.253906 C 292.292969 573.03125 292.855469 572.859375 293.433594 572.742188 C 294.011719 572.628906 294.597656 572.570312 295.191406 572.570312 L 468.691406 572.570312 C 469.28125 572.570312 469.867188 572.511719 470.445312 572.398438 C 471.023438 572.28125 471.585938 572.109375 472.132812 571.886719 C 472.679688 571.660156 473.199219 571.382812 473.6875 571.054688 C 474.179688 570.726562 474.636719 570.351562 475.054688 569.933594 C 475.46875 569.515625 475.84375 569.0625 476.171875 568.570312 C 476.5 568.078125 476.777344 567.558594 477.003906 567.011719 C 477.230469 566.46875 477.398438 565.90625 477.515625 565.324219 C 477.628906 564.746094 477.6875 564.160156 477.6875 563.570312 L 477.6875 511.910156 C 477.6875 511.320312 477.628906 510.734375 477.515625 510.15625 C 477.398438 509.574219 477.230469 509.011719 477.003906 508.464844 C 476.777344 507.921875 476.5 507.402344 476.171875 506.910156 C 475.84375 506.417969 475.46875 505.964844 475.054688 505.546875 C 474.636719 505.128906 474.179688 504.753906 473.6875 504.425781 C 473.199219 504.097656 472.679688 503.820312 472.132812 503.59375 C 471.585938 503.367188 471.023438 503.199219 470.445312 503.082031 C 469.867188 502.96875 469.28125 502.910156 468.691406 502.910156 Z M 295.191406 502.910156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 552 482 L 581 482 L 581 592.78125 L 552 592.78125 Z M 552 482"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 516 482 L 545 482 L 545 592.78125 L 516 592.78125 Z M 516 482"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 727 258 L 753 258 L 753 374 L 727 374 Z M 727 258"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 752.71875 357.835938 C 752.71875 358.355469 752.691406 358.875 752.640625 359.394531 C 752.589844 359.910156 752.511719 360.425781 752.40625 360.9375 C 752.304688 361.449219 752.179688 361.953125 752.027344 362.449219 C 751.875 362.949219 751.699219 363.4375 751.496094 363.917969 C 751.296875 364.398438 751.074219 364.867188 750.828125 365.328125 C 750.582031 365.785156 750.3125 366.230469 750.023438 366.664062 C 749.734375 367.097656 749.421875 367.515625 749.089844 367.917969 C 748.761719 368.320312 748.410156 368.703125 748.042969 369.070312 C 747.671875 369.4375 747.285156 369.789062 746.882812 370.117188 C 746.480469 370.445312 746.0625 370.757812 745.628906 371.046875 C 745.195312 371.332031 744.75 371.601562 744.289062 371.84375 C 743.832031 372.089844 743.359375 372.3125 742.878906 372.511719 C 742.398438 372.710938 741.90625 372.882812 741.410156 373.035156 C 740.910156 373.183594 740.40625 373.3125 739.894531 373.410156 C 739.382812 373.511719 738.871094 373.589844 738.351562 373.640625 C 737.832031 373.691406 737.3125 373.714844 736.792969 373.714844 L 727.058594 373.714844 L 727.058594 359.457031 L 732.167969 359.457031 C 738.753906 359.457031 740.519531 354.109375 740.535156 347.519531 C 740.535156 342.261719 740.355469 334.71875 739.800781 323.972656 C 739.445312 316.953125 738.578125 309.996094 737.191406 303.105469 L 737.191406 303.085938 C 734.453125 289.675781 730.242188 280.277344 727.058594 275.867188 L 727.058594 258.746094 C 730.699219 263.183594 733.875 267.9375 736.578125 273.003906 C 741.09375 281.234375 744.632812 289.871094 747.191406 298.90625 C 749.75 307.941406 751.261719 317.148438 751.730469 326.527344 C 752.488281 340.820312 752.71875 350.851562 752.71875 357.835938 Z M 752.71875 357.835938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 413.904,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 171.006,
    x2: 413.904,
    gradientUnits: "userSpaceOnUse",
    y2: 265.448,
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4976",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4976",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594975",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594874",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584874",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584773",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574773",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574772",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564671",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554671",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554570",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54456F",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54456F",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446E",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446E",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52446D",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52436C",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51436C",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51426B",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426B",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426A",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4067",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E65",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E64",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3E64",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3D63",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493D63",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493C62",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C61",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C61",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463B5F",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463A5E",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#453A5E",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45395D",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44395D",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43395C",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43385B",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42385B",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42375A",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41375A",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413759",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3557",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3556",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3556",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3455",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3455",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3354",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3353",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3353",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3252",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3252",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3251",
    offset: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393150",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 629 245 L 728 245 L 728 374 L 629 374 Z M 629 245"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 727.058594 258.746094 L 727.058594 373.714844 L 629.210938 373.714844 L 629.210938 274.625 C 629.210938 273.261719 629.304688 271.90625 629.492188 270.554688 C 629.679688 269.207031 629.960938 267.875 630.332031 266.566406 C 630.707031 265.253906 631.167969 263.976562 631.71875 262.730469 C 632.269531 261.480469 632.902344 260.28125 633.621094 259.121094 C 634.339844 257.960938 635.132812 256.859375 636.003906 255.8125 C 636.875 254.761719 637.8125 253.78125 638.820312 252.863281 C 639.828125 251.945312 640.894531 251.101562 642.015625 250.332031 C 643.140625 249.5625 644.3125 248.875 645.535156 248.269531 C 649.65625 246.203125 654.023438 245.175781 658.636719 245.1875 L 713.507812 245.1875 C 713.78125 245.183594 714.058594 245.195312 714.332031 245.226562 C 715.1875 245.277344 716.027344 245.40625 716.855469 245.617188 C 717.683594 245.828125 718.488281 246.113281 719.261719 246.476562 C 720.035156 246.839844 720.769531 247.269531 721.460938 247.773438 C 722.152344 248.273438 722.792969 248.835938 723.378906 249.457031 C 723.964844 250.082031 724.488281 250.753906 724.945312 251.476562 C 725.402344 252.195312 725.789062 252.957031 726.105469 253.75 C 726.421875 254.546875 726.660156 255.363281 726.816406 256.203125 C 726.976562 257.042969 727.058594 257.890625 727.058594 258.746094 Z M 727.058594 258.746094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 363.156,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 159.86,
    x2: 363.156,
    gradientUnits: "userSpaceOnUse",
    y2: 265.447,
    id: "r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4976",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4976",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594975",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594874",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584874",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584773",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574773",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574772",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564671",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554671",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554570",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54456F",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54456F",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446E",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446E",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52446D",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52436C",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51436C",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51426B",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426B",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426A",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4067",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E65",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E64",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3E64",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3D63",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493D63",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493C62",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C61",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C61",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463B5F",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463A5E",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#453A5E",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45395D",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44395D",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43395C",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43385B",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42385B",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42375A",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41375A",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413759",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3557",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3556",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3556",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3455",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3455",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3354",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3353",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3353",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3252",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3252",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3251",
    offset: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393150",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 645 245 L 715 245 L 715 301 L 645 301 Z M 645 245"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 714.335938 245.226562 L 714.335938 288.019531 C 714.335938 288.847656 714.253906 289.667969 714.09375 290.476562 C 713.933594 291.289062 713.695312 292.078125 713.378906 292.84375 C 713.0625 293.609375 712.671875 294.335938 712.214844 295.023438 C 711.753906 295.710938 711.230469 296.347656 710.648438 296.933594 C 710.0625 297.519531 709.425781 298.039062 708.738281 298.5 C 708.050781 298.960938 707.324219 299.347656 706.558594 299.664062 C 705.792969 299.980469 705.007812 300.21875 704.195312 300.378906 C 703.382812 300.542969 702.5625 300.621094 701.738281 300.621094 L 658.132812 300.621094 C 657.304688 300.621094 656.484375 300.542969 655.671875 300.378906 C 654.859375 300.21875 654.074219 299.980469 653.308594 299.664062 C 652.542969 299.347656 651.816406 298.960938 651.128906 298.5 C 650.441406 298.039062 649.804688 297.519531 649.21875 296.933594 C 648.636719 296.347656 648.113281 295.710938 647.652344 295.023438 C 647.195312 294.335938 646.804688 293.609375 646.488281 292.84375 C 646.171875 292.078125 645.933594 291.289062 645.773438 290.476562 C 645.613281 289.667969 645.53125 288.847656 645.535156 288.019531 L 645.535156 248.265625 C 649.65625 246.203125 654.023438 245.175781 658.636719 245.1875 L 713.507812 245.1875 C 713.78125 245.183594 714.058594 245.195312 714.335938 245.226562 Z M 714.335938 245.226562"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 364.635,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 159.859,
    x2: 364.635,
    gradientUnits: "userSpaceOnUse",
    y2: 205.406,
    id: "u"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C8C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C8C",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8B8B",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8B8B",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8A8B",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8A8A",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD898A",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8989",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8889",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8788",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8788",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8688",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8687",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98587",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98586",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88486",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88485",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88385",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78385",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78284",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68284",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68183",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58183",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58082",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48082",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47F82",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37E81",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37E81",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37D80",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F27D80",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F27C80",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17C7F",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17B7F",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07B7E",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07A7E",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF7A7D",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF797D",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE797D",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE787C",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE787C",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED777B",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED777B",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC767A",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC757A",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB757A",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB7479",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA7479",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA7378",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97378",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97278",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97277",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87177",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87176",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E77076",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E77075",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E66F75",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E66F75",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E56E74",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E56E74",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E46D73",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E46C73",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E46C72",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E36B72",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E36B72",
    offset: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E26A71",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 672 281 L 683 281 L 683 292 L 672 292 Z M 672 281"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 682.761719 286.703125 C 682.761719 287.042969 682.726562 287.382812 682.660156 287.714844 C 682.59375 288.046875 682.496094 288.371094 682.367188 288.6875 C 682.238281 289 682.078125 289.300781 681.886719 289.582031 C 681.699219 289.867188 681.484375 290.128906 681.246094 290.367188 C 681.003906 290.609375 680.742188 290.824219 680.460938 291.011719 C 680.175781 291.203125 679.878906 291.359375 679.5625 291.492188 C 679.25 291.621094 678.925781 291.71875 678.59375 291.785156 C 678.257812 291.851562 677.921875 291.886719 677.582031 291.886719 C 677.242188 291.886719 676.90625 291.851562 676.570312 291.785156 C 676.238281 291.71875 675.914062 291.621094 675.601562 291.492188 C 675.285156 291.359375 674.988281 291.203125 674.703125 291.011719 C 674.421875 290.824219 674.160156 290.609375 673.917969 290.367188 C 673.679688 290.128906 673.464844 289.867188 673.277344 289.582031 C 673.085938 289.300781 672.925781 289 672.796875 288.6875 C 672.667969 288.371094 672.570312 288.050781 672.503906 287.714844 C 672.4375 287.382812 672.402344 287.042969 672.402344 286.703125 C 672.402344 286.363281 672.4375 286.027344 672.503906 285.695312 C 672.570312 285.359375 672.667969 285.035156 672.796875 284.722656 C 672.925781 284.40625 673.085938 284.109375 673.277344 283.824219 C 673.464844 283.542969 673.679688 283.28125 673.917969 283.039062 C 674.160156 282.800781 674.421875 282.585938 674.703125 282.398438 C 674.988281 282.207031 675.285156 282.046875 675.601562 281.917969 C 675.914062 281.789062 676.238281 281.6875 676.570312 281.621094 C 676.90625 281.554688 677.242188 281.523438 677.582031 281.523438 C 677.921875 281.523438 678.257812 281.554688 678.59375 281.621094 C 678.925781 281.6875 679.25 281.789062 679.5625 281.917969 C 679.878906 282.046875 680.175781 282.207031 680.460938 282.398438 C 680.742188 282.585938 681.003906 282.800781 681.242188 283.039062 C 681.484375 283.28125 681.699219 283.542969 681.886719 283.824219 C 682.078125 284.109375 682.238281 284.40625 682.367188 284.722656 C 682.496094 285.035156 682.59375 285.359375 682.660156 285.695312 C 682.726562 286.027344 682.761719 286.363281 682.761719 286.703125 Z M 682.761719 286.703125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 362.702,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 189.717,
    x2: 362.702,
    gradientUnits: "userSpaceOnUse",
    y2: 198.229,
    id: "x"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFDFE",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFCFE",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFBFD",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFBFD",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFAFD",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF9FC",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF8FC",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF8FC",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF7FB",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6FB",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5FB",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F4FA",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4FA",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F3FA",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F2F9",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F1F9",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F1F9",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F0F8",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EFF8",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EEF8",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EDF7",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EDF7",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3ECF7",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3EBF6",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3EAF6",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2EAF6",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2E9F5",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E8F5",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E7F5",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0E6F4",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 629 323 L 728 323 L 728 374 L 629 374 Z M 629 323"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 653.34375 323.226562 L 702.925781 323.226562 C 703.714844 323.226562 704.503906 323.265625 705.292969 323.34375 C 706.078125 323.417969 706.859375 323.535156 707.632812 323.6875 C 708.410156 323.84375 709.175781 324.035156 709.929688 324.265625 C 710.6875 324.496094 711.429688 324.761719 712.160156 325.0625 C 712.890625 325.367188 713.605469 325.703125 714.300781 326.074219 C 715 326.449219 715.675781 326.855469 716.332031 327.292969 C 716.988281 327.734375 717.625 328.203125 718.234375 328.707031 C 718.847656 329.207031 719.429688 329.738281 719.988281 330.296875 C 720.546875 330.855469 721.078125 331.441406 721.578125 332.050781 C 722.082031 332.664062 722.550781 333.296875 722.992188 333.953125 C 723.429688 334.613281 723.835938 335.289062 724.207031 335.988281 C 724.582031 336.683594 724.917969 337.398438 725.21875 338.128906 C 725.523438 338.859375 725.789062 339.601562 726.019531 340.359375 C 726.246094 341.117188 726.441406 341.882812 726.59375 342.65625 C 726.75 343.433594 726.863281 344.214844 726.941406 345 C 727.019531 345.785156 727.058594 346.574219 727.058594 347.367188 L 727.058594 373.714844 L 629.210938 373.714844 L 629.210938 347.367188 C 629.210938 346.574219 629.25 345.785156 629.328125 345 C 629.40625 344.214844 629.519531 343.433594 629.675781 342.65625 C 629.828125 341.882812 630.019531 341.117188 630.25 340.359375 C 630.480469 339.601562 630.746094 338.859375 631.046875 338.128906 C 631.351562 337.398438 631.6875 336.683594 632.058594 335.988281 C 632.433594 335.289062 632.839844 334.613281 633.277344 333.953125 C 633.71875 333.296875 634.1875 332.664062 634.6875 332.050781 C 635.191406 331.441406 635.71875 330.855469 636.277344 330.296875 C 636.835938 329.738281 637.421875 329.207031 638.035156 328.707031 C 638.644531 328.203125 639.277344 327.734375 639.9375 327.292969 C 640.59375 326.855469 641.269531 326.449219 641.96875 326.074219 C 642.664062 325.703125 643.378906 325.367188 644.109375 325.0625 C 644.835938 324.761719 645.582031 324.496094 646.335938 324.265625 C 647.09375 324.035156 647.859375 323.84375 648.632812 323.6875 C 649.410156 323.535156 650.191406 323.417969 650.976562 323.34375 C 651.765625 323.265625 652.550781 323.226562 653.34375 323.226562 Z M 653.34375 323.226562"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 363.156,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 223.973,
    x2: 363.156,
    gradientUnits: "userSpaceOnUse",
    y2: 265.447,
    id: "A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C8C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C8C",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8B8B",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8B8B",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8A8B",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8A8A",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC898A",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8989",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8889",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8788",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8788",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8688",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8687",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98587",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98586",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88486",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88485",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88385",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78385",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78284",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68284",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68183",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58183",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58082",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48082",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47F82",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37E81",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37E81",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37D80",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F27D80",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F27C80",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17C7F",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17B7F",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07B7E",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07A7E",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF7A7D",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF797D",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE797D",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE787C",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE787C",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED777B",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED777B",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC767A",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC757A",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB757A",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB7479",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA7479",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA7378",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97378",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97278",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97277",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87177",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87176",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E77076",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E77075",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E66F75",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E66F75",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E56E74",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E56E74",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E46D73",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E46C73",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E46C72",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E36B72",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E36B72",
    offset: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E26A71",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 707.222656 319.589844 L 712.839844 319.589844 L 712.839844 333.148438 L 707.222656 333.148438 Z M 707.222656 319.589844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 389.367,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 220.986,
    x2: 389.367,
    gradientUnits: "userSpaceOnUse",
    y2: 232.123,
    id: "C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFDFE",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFCFE",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFBFD",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFBFD",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFAFD",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF9FC",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF8FC",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF8FC",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF7FB",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6FB",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5FB",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F4FA",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4FA",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F3FA",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F2F9",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F1F9",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F1F9",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F0F8",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EFF8",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EEF8",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EDF7",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EDF7",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3ECF7",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3EBF6",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3EAF6",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2EAF6",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2E9F5",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E8F5",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E7F5",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0E6F4",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 649.632812 319.589844 L 655.25 319.589844 L 655.25 333.148438 L 649.632812 333.148438 Z M 649.632812 319.589844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 342.043,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 220.986,
    x2: 342.043,
    gradientUnits: "userSpaceOnUse",
    y2: 232.123,
    id: "E"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFDFE",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFCFE",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFBFD",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFBFD",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFAFD",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF9FC",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF8FC",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF8FC",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF7FB",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6FB",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5FB",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F4FA",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4FA",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F3FA",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F2F9",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F1F9",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F1F9",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F0F8",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EFF8",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EEF8",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EDF7",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EDF7",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3ECF7",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3EBF6",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3EAF6",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2EAF6",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2E9F5",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E8F5",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E7F5",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0E6F4",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 468 145 L 507 145 L 507 302 L 468 302 Z M 468 145"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 468.085938 165.632812 C 468.085938 165.632812 477.296875 224.710938 475.09375 240.144531 C 472.890625 255.574219 471.832031 295.761719 474.71875 300.105469 C 477.601562 304.449219 506.386719 297.460938 506.386719 297.460938 L 496.246094 145.378906 Z M 468.085938 165.632812"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 206.283,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 77.882,
    x2: 206.283,
    gradientUnits: "userSpaceOnUse",
    y2: 208.549,
    id: "H"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC260",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC260",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC15F",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC05F",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBF5E",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBE5D",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBD5D",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBC5C",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBB5C",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABA5B",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB95B",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B85A",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B75A",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B659",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B659",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B558",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6B458",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B357",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B257",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B156",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B055",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3AF55",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3AE54",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2AD54",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1AC53",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1AB53",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0AA52",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0AA52",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA951",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA851",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEA750",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA650",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA54F",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 465 138 L 497 138 L 497 166 L 465 166 Z M 465 138"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 489.851562 138.640625 L 465.066406 157.835938 L 468.085938 165.632812 L 496.25 145.378906 Z M 489.851562 138.640625"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 200.877,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 72.347,
    x2: 200.877,
    gradientUnits: "userSpaceOnUse",
    y2: 94.518,
    id: "K"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD99C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD99C",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD89B",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED89B",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED79B",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED79A",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED69A",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD599",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD599",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD498",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD498",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD398",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD397",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD297",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD296",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD196",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD196",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD095",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCF95",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACF94",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE94",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE93",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACD93",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CD93",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CC92",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CC92",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CB91",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CB91",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CA90",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C990",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C990",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C88F",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C88F",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C78E",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C78E",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C68D",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C68D",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C58D",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C58C",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C48C",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C38B",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C38B",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C28B",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C28A",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C18A",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C189",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C089",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3C088",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3BF88",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3BF88",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3BE87",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BD87",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BD86",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BC86",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BC85",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1BB85",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1BB85",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1BA84",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1BA84",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B983",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B983",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B883",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B782",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFB782",
    offset: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFB681",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 474 145 L 549 145 L 549 325 L 474 325 Z M 474 145"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 480.824219 146.597656 C 480.824219 146.597656 474.371094 149.761719 474.730469 165.191406 C 475.09375 180.625 480.375 254.695312 478.394531 269.683594 C 476.414062 284.675781 475.09375 324.574219 475.09375 324.574219 C 475.09375 324.574219 526.070312 321.851562 539.730469 321.988281 C 553.394531 322.125 547.554688 271.886719 541.292969 237.5 C 535.03125 203.109375 494.484375 135.496094 480.824219 146.597656 Z M 480.824219 146.597656"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 226.134,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 69.763,
    x2: 226.134,
    gradientUnits: "userSpaceOnUse",
    y2: 225.082,
    id: "N"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFF",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFDFE",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFDFE",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFCFE",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFBFD",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFAFD",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF9FD",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF9FC",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF8FC",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF7FB",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6FB",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5FB",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F4FA",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4FA",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F3FA",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F2F9",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F1F9",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F0F9",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EFF8",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EFF8",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EEF7",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EDF7",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4ECF7",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3EBF6",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3EBF6",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2EAF6",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2E9F5",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E8F5",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E7F5",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0E6F4",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 421 295 L 466 295 L 466 311 L 421 311 Z M 421 295"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 461.3125 295.203125 C 455.789062 295.574219 450.320312 296.324219 444.902344 297.460938 C 440.242188 298.644531 435.722656 300.234375 431.351562 302.234375 C 430.359375 303.40625 429.171875 304.324219 427.789062 304.992188 C 426.410156 305.65625 424.949219 306.011719 423.417969 306.058594 C 418.460938 306.058594 423.417969 310.027344 423.417969 310.027344 L 465.066406 310.027344 Z M 461.3125 295.203125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 170.047,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 200.955,
    x2: 170.047,
    gradientUnits: "userSpaceOnUse",
    y2: 213.13,
    id: "Q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCB9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCB9",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCBB8",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCAB7",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC9B7",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC8B6",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC7B5",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC7B5",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC6B4",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC5B3",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC4B3",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC3B2",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC2B1",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC1B1",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC1B0",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC0AF",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBFAF",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBEAE",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBDAD",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBCAD",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBCAC",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBBAB",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBAAB",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB9AA",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB8AA",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB7A9",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB6A8",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB6A8",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB5A7",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB4A6",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB3A6",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2A5",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB1A4",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB1A4",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB0A3",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAFA2",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AEA2",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ADA1",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ACA0",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ABA0",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AB9F",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA9E",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A99E",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A89D",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A79C",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A69C",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A69B",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A59A",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A49A",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A399",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A299",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A198",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A097",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A097",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F96",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79E95",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69D95",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69C94",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69B93",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69B93",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69A92",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69991",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59891",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59790",
    offset: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5968F",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 460 292 L 475 292 L 475 313 L 460 313 Z M 460 292"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 469.609375 292.128906 L 462.421875 292.128906 C 462.421875 292.128906 459.445312 298.453125 460.769531 304.074219 C 461.394531 307.238281 462.8125 309.992188 465.019531 312.339844 L 474.730469 312.320312 Z M 469.609375 292.128906"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 190.132,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 198.43,
    x2: 190.132,
    gradientUnits: "userSpaceOnUse",
    y2: 215.032,
    id: "T"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC260",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC260",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC15F",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC05F",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBF5E",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBE5E",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBD5D",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBC5C",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBB5C",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABA5B",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB95B",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B95A",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B85A",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B759",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B659",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B558",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6B458",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6B357",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B257",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B156",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B056",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3AF55",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3AF55",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2AE54",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2AD54",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1AC53",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1AB52",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0AA52",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA951",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA851",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEA750",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEA650",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA54F",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 365 244 L 401 244 L 401 316 L 365 316 Z M 365 244"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 370.921875 244.789062 L 400.316406 312.414062 L 393.023438 315.585938 L 366.480469 254.53125 C 366.292969 254.101562 366.148438 253.65625 366.046875 253.195312 C 365.949219 252.734375 365.894531 252.269531 365.886719 251.800781 C 365.878906 251.332031 365.917969 250.863281 366 250.402344 C 366.082031 249.9375 366.210938 249.488281 366.382812 249.050781 C 366.554688 248.613281 366.769531 248.199219 367.023438 247.800781 C 367.277344 247.40625 367.566406 247.039062 367.894531 246.703125 C 368.222656 246.363281 368.578125 246.058594 368.964844 245.792969 C 369.347656 245.523438 369.757812 245.296875 370.1875 245.109375 Z M 370.921875 244.789062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 120.709,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 159.543,
    x2: 120.709,
    gradientUnits: "userSpaceOnUse",
    y2: 217.698,
    id: "W"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4976",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4976",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594975",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594874",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584874",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584773",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574773",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574772",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564671",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554671",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554570",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54456F",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54456F",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446E",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446E",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52446D",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52436C",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51436C",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51426B",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426B",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426A",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4067",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E65",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E64",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3E64",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3D63",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493D63",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493C62",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C61",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C61",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463B5F",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463A5E",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#453A5E",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45395D",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44395D",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43395C",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43385B",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42385B",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42375A",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41375A",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413759",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3557",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3556",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3556",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3455",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3455",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3354",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3353",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3353",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3252",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3252",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3251",
    offset: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393150",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 391 310 L 466 310 L 466 318 L 391 318 Z M 391 310"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 391.355469 310.027344 L 457.109375 310.027344 C 457.632812 310.027344 458.152344 310.078125 458.664062 310.179688 C 459.175781 310.28125 459.671875 310.433594 460.15625 310.632812 C 460.636719 310.832031 461.097656 311.078125 461.53125 311.367188 C 461.964844 311.65625 462.367188 311.988281 462.738281 312.355469 C 463.105469 312.726562 463.4375 313.128906 463.726562 313.5625 C 464.015625 313.996094 464.261719 314.457031 464.460938 314.9375 C 464.660156 315.421875 464.8125 315.917969 464.914062 316.433594 C 465.015625 316.945312 465.066406 317.460938 465.066406 317.984375 L 397.480469 317.984375 C 397.078125 317.984375 396.679688 317.945312 396.285156 317.867188 C 395.890625 317.789062 395.507812 317.671875 395.136719 317.519531 C 394.765625 317.363281 394.410156 317.175781 394.078125 316.953125 C 393.742188 316.726562 393.433594 316.472656 393.148438 316.1875 C 392.863281 315.90625 392.609375 315.59375 392.386719 315.261719 C 392.164062 314.925781 391.972656 314.574219 391.820312 314.199219 C 391.667969 313.828125 391.550781 313.445312 391.472656 313.050781 C 391.394531 312.65625 391.355469 312.257812 391.355469 311.855469 Z M 391.355469 310.027344"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 157.778,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 213.131,
    x2: 157.778,
    gradientUnits: "userSpaceOnUse",
    y2: 219.668,
    id: "Z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4976",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4976",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594975",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594874",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584874",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584773",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574773",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574772",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564671",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554671",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554570",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54456F",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54456F",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446E",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446E",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52446D",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52436C",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51436C",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51426B",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426B",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426A",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4067",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E65",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E64",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3E64",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3D63",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493D63",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493C62",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C61",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C61",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463B5F",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463A5E",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#453A5E",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45395D",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44395D",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43395C",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43385B",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42385B",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42375A",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41375A",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413759",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3557",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3556",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3556",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3455",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3455",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3354",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3353",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3353",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3252",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3252",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3251",
    offset: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393150",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 428 56 L 511 56 L 511 119 L 428 119 Z M 428 56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 501.949219 118.847656 C 501.949219 118.847656 512.113281 112.726562 510.792969 95.53125 C 509.46875 78.335938 494.476562 57.613281 478.394531 56.730469 C 462.3125 55.851562 449.53125 79.21875 440.273438 80.980469 C 431.019531 82.746094 424.851562 87.582031 431.902344 91.554688 C 438.953125 95.53125 436.308594 108.316406 433.664062 113.167969 C 431.019531 118.015625 449.671875 117.910156 458.34375 106.996094 C 467.015625 96.078125 501.949219 118.847656 501.949219 118.847656 Z M 501.949219 118.847656"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 192.021,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 4.337,
    x2: 192.021,
    gradientUnits: "userSpaceOnUse",
    y2: 56.088,
    id: "ac"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4976",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4975",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594975",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594874",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584874",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574773",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574772",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564772",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564671",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554671",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554570",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54456F",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54456F",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446E",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446D",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52436D",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52436C",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51436C",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426B",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426A",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F416A",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4168",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4067",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D3F67",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F65",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E65",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E64",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3D64",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3D63",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493D62",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C62",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C61",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463B5F",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463A5F",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#453A5E",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45395D",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44395D",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44395C",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43385C",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43385B",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42375A",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41375A",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413759",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3657",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3557",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3556",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3455",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3455",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3454",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3353",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3353",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3252",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3252",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3251",
    offset: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393150",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 475 109 L 505 109 L 505 168 L 475 168 Z M 475 109"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 500.214844 109.640625 L 504.613281 137.855469 C 504.613281 137.855469 494.925781 161.664062 486.992188 166.074219 C 479.058594 170.484375 477.730469 164.75 478.394531 159.460938 C 479.058594 154.167969 482.585938 152.40625 482.585938 152.40625 L 475.09375 127.714844 Z M 500.214844 109.640625"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 208.434,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 48.522,
    x2: 208.434,
    gradientUnits: "userSpaceOnUse",
    y2: 98.502,
    id: "af"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCB9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCB9",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCBB8",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCAB7",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC9B6",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC8B6",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC7B5",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC6B4",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC5B4",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC4B3",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC4B2",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC3B2",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC2B1",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC1B0",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC0B0",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBFAF",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBEAE",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBDAE",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBCAD",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBCAC",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBBAC",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBAAB",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB9AA",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB8A9",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB7A9",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB6A8",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB5A7",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB5A7",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB4A6",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB3A5",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2A5",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB1A4",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB0A3",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAFA3",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAEA2",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ADA1",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ADA1",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ACA0",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AB9F",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA9E",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A99E",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A89D",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A79C",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A69C",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A59B",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A59A",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A49A",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A399",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A298",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A198",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A097",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F96",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79E96",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69D95",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69D94",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69C94",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69B93",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69A92",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69991",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59891",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59790",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5968F",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 454 91 L 505 91 L 505 144 L 454 144 Z M 454 91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 458.125 102.347656 C 457.269531 103.019531 456.535156 103.800781 455.917969 104.691406 C 455.300781 105.585938 454.832031 106.550781 454.503906 107.585938 C 454.179688 108.621094 454.015625 109.683594 454.011719 110.769531 C 454.007812 111.855469 454.167969 112.914062 454.484375 113.953125 C 455.695312 117.898438 459.535156 125.386719 459.054688 128.277344 C 458.128906 133.847656 464.722656 131.007812 469.363281 135.652344 C 474.003906 140.296875 474.074219 148.976562 485.667969 138.296875 C 497.265625 127.617188 505.058594 118.03125 504.59375 107.351562 C 504.128906 96.671875 492.996094 100.386719 492.070312 107.351562 C 491.140625 114.316406 487.921875 91.097656 478.398438 91.5625 C 472.503906 91.851562 463.855469 97.832031 458.125 102.347656 Z M 458.125 102.347656"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 199.772,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 33.292,
    x2: 199.772,
    gradientUnits: "userSpaceOnUse",
    y2: 80.837,
    id: "ai"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC2B1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC1B1",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC1B0",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC0B0",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC0AF",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBFAF",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBEAE",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBEAE",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBDAD",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBDAD",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBCAD",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBBAC",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBBAC",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBAAB",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBAAB",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB9AA",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB8AA",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB8A9",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB7A9",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB7A8",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB6A8",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB6A8",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB5A7",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB4A7",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB4A6",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB3A6",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB3A5",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2A5",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB1A4",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB1A4",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB0A3",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB0A3",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAFA2",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAEA2",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AEA2",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ADA1",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ADA1",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ACA0",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ABA0",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AB9F",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA9F",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA9E",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A99E",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A99E",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A89D",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A79C",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A79C",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A69C",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A69B",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A59B",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A49A",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A49A",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A399",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A399",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A298",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 464 107 L 470 107 L 470 116 L 464 116 Z M 464 107"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 469.046875 110.949219 C 469.257812 111.472656 469.414062 111.996094 469.519531 112.515625 C 469.621094 113.035156 469.664062 113.511719 469.648438 113.949219 C 469.628906 114.386719 469.550781 114.75 469.414062 115.035156 C 469.277344 115.324219 469.089844 115.515625 468.855469 115.609375 C 468.621094 115.703125 468.355469 115.691406 468.058594 115.578125 C 467.761719 115.464844 467.457031 115.257812 467.140625 114.953125 C 466.828125 114.648438 466.527344 114.273438 466.246094 113.824219 C 465.960938 113.375 465.714844 112.890625 465.503906 112.367188 C 465.296875 111.84375 465.140625 111.320312 465.035156 110.800781 C 464.929688 110.28125 464.890625 109.804688 464.90625 109.367188 C 464.925781 108.929688 465.003906 108.566406 465.140625 108.28125 C 465.277344 107.992188 465.460938 107.800781 465.695312 107.707031 C 465.929688 107.613281 466.199219 107.625 466.496094 107.738281 C 466.792969 107.851562 467.097656 108.058594 467.414062 108.363281 C 467.726562 108.667969 468.023438 109.042969 468.308594 109.492188 C 468.59375 109.9375 468.839844 110.425781 469.046875 110.949219 Z M 469.046875 110.949219"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 249.016,
    gradientTransform: "matrix(1.38905 -.0689 -.06882 1.24486 123.22 95.8)",
    y1: 23.169,
    x2: 249.016,
    gradientUnits: "userSpaceOnUse",
    y2: 29.875,
    id: "al"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4976",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594975",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594875",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584874",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584873",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574773",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574772",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564672",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564671",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554670",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554570",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54456F",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54446E",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446E",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52446D",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52436D",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51436C",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51426B",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426B",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426A",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4067",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E65",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E64",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3E64",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3D63",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493D63",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493C62",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C61",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C61",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463A5F",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#453A5E",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#453A5E",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44395D",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44395C",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43385C",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43385B",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42385B",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42375A",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413759",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413659",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403657",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3557",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3556",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3456",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3455",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3454",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3354",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3353",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3252",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3252",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3251",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393150",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 486 137 L 596 137 L 596 327 L 486 327 Z M 486 137"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 595.734375 306.09375 C 595.628906 307.191406 595.378906 308.25 594.976562 309.277344 C 594.578125 310.304688 594.046875 311.257812 593.382812 312.136719 C 592.71875 313.015625 591.945312 313.785156 591.070312 314.449219 C 590.191406 315.117188 589.238281 315.648438 588.214844 316.050781 C 576.730469 320.566406 551.085938 328.832031 524.019531 325.230469 C 492.492188 321.054688 492.722656 316.554688 492.8125 310.59375 C 492.855469 309.597656 492.824219 308.597656 492.722656 307.605469 C 491.84375 300.097656 501.09375 271.457031 492.722656 223.386719 C 488.710938 200.414062 487.234375 186.300781 486.785156 177.839844 L 486.785156 177.820312 C 486.28125 168.601562 487 166.082031 487 166.082031 L 504.621094 137.855469 C 504.621094 137.855469 508.019531 137.691406 513.652344 141.113281 C 520.851562 145.488281 531.742188 155.730469 543.851562 179.746094 C 560.175781 212.0625 567.425781 236.835938 576.480469 255.179688 C 579.144531 260.800781 582.371094 266.074219 586.160156 271.003906 C 595.953125 283.410156 596.507812 297.703125 595.734375 306.09375 Z M 595.734375 306.09375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 250.705,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 71.566,
    x2: 250.705,
    gradientUnits: "userSpaceOnUse",
    y2: 228.578,
    id: "ao"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC260",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC260",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC15F",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC05F",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBF5E",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBE5D",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBD5D",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBC5C",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBB5C",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABA5B",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB95B",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B85A",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B75A",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B759",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B659",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B558",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6B458",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6B357",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B257",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B156",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B055",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3AF55",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3AE54",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2AD54",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2AC53",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1AB53",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0AB52",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0AA52",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA951",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA851",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEA750",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA650",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA54F",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 486 137 L 514 137 L 514 178 L 486 178 Z M 486 137"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 513.652344 141.113281 L 486.785156 177.820312 C 486.28125 168.601562 487 166.082031 487 166.082031 L 504.621094 137.855469 C 504.621094 137.855469 508.019531 137.691406 513.652344 141.113281 Z M 513.652344 141.113281"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 216.879,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 71.566,
    x2: 216.879,
    gradientUnits: "userSpaceOnUse",
    y2: 104.53,
    id: "ar"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD99C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD99C",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED89B",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED79B",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED79A",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED69A",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD699",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD599",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD499",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD498",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD398",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD397",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD297",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD296",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD196",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD196",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD095",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD095",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACF94",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE94",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE93",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACD93",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CD93",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CC92",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CC92",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CB91",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CB91",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CA91",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CA90",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C990",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C88F",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C88F",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C78E",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C78E",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C68E",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C68D",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C58D",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C58C",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C48C",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C38B",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C38B",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C28B",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C28A",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C18A",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C189",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C089",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3C088",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3BF88",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3BF88",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3BE87",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BD87",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BD86",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BC86",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BC85",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1BB85",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1BB85",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1BA84",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1BA84",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B983",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B983",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B883",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B782",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFB782",
    offset: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFB681",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 468 170 L 577 170 L 577 315 L 468 315 Z M 468 170"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "at"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 519.738281 170.4375 C 519.738281 170.4375 505.722656 171.804688 515.308594 206.195312 C 524.894531 240.585938 539.109375 285.554688 539.109375 285.554688 C 539.109375 285.554688 475.3125 286.21875 471.015625 290.1875 C 466.71875 294.152344 467.046875 308.042969 472.667969 311.679688 C 478.289062 315.316406 570.511719 314.65625 575.46875 310.027344 C 580.425781 305.398438 563.238281 241.90625 551.667969 212.148438 C 540.101562 182.386719 531.96875 168.921875 519.738281 170.4375 Z M 519.738281 170.4375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 235.028,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 97.22,
    x2: 235.028,
    gradientUnits: "userSpaceOnUse",
    y2: 217.477,
    id: "au"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD99C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD99C",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD89B",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED79B",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED79A",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED69A",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD69A",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD599",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD599",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD498",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD498",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD397",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD297",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD297",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD196",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD196",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD095",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD095",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACF94",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE94",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE93",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACD93",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CD93",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CC92",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CC92",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CB91",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CB91",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CA90",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C990",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C990",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C88F",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C88F",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C78E",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C78E",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C68D",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C68D",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C58D",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C48C",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C48C",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C38B",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C38B",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C28A",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C28A",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C18A",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C189",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C089",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3BF88",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3BF88",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3BE87",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BE87",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BD87",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BD86",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BC86",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1BC85",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1BB85",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1BA84",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1BA84",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B984",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B983",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B883",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B882",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFB782",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFB681",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 356 493 L 381 493 L 381 519 L 356 519 Z M 356 493"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 361.605469 493.878906 L 356.976562 509.75 C 356.976562 509.75 366.089844 524.800781 372.511719 515.550781 C 379.273438 505.816406 380.242188 499.402344 380.242188 499.402344 Z M 361.605469 493.878906"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 108.801,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 364.158,
    x2: 108.801,
    gradientUnits: "userSpaceOnUse",
    y2: 389.557,
    id: "ax"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCB9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCB9",
    offset: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCBB8",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCBB8",
    offset: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCAB7",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCAB7",
    offset: 0.039
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC9B7",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC9B6",
    offset: 0.055
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC8B6",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC7B5",
    offset: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC7B5",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC6B5",
    offset: 0.086
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC6B4",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC5B4",
    offset: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC5B3",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC4B3",
    offset: 0.117
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC4B3",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC3B2",
    offset: 0.133
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC3B2",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC2B1",
    offset: 0.148
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC2B1",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC1B0",
    offset: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC1B0",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC0B0",
    offset: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC0AF",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBFAF",
    offset: 0.195
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBFAE",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBEAE",
    offset: 0.211
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBDAE",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBDAD",
    offset: 0.227
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBCAD",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBCAC",
    offset: 0.242
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBBAC",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBBAC",
    offset: 0.258
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBAAB",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBAAB",
    offset: 0.273
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB9AA",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB9AA",
    offset: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB8AA",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB8A9",
    offset: 0.305
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB7A9",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB7A8",
    offset: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB6A8",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB6A7",
    offset: 0.336
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB5A7",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB4A7",
    offset: 0.352
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB4A6",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB3A6",
    offset: 0.367
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB3A5",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2A5",
    offset: 0.383
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2A5",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB1A4",
    offset: 0.398
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB1A4",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB0A3",
    offset: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB0A3",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAFA3",
    offset: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAFA2",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AEA2",
    offset: 0.445
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AEA1",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ADA1",
    offset: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ADA1",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ACA0",
    offset: 0.477
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ABA0",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AB9F",
    offset: 0.492
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA9F",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA9E",
    offset: 0.508
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A99E",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A99E",
    offset: 0.523
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A89D",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A89D",
    offset: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A79C",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A79C",
    offset: 0.555
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A69C",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A69B",
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A59B",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A59A",
    offset: 0.586
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A49A",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A49A",
    offset: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A399",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A299",
    offset: 0.617
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A298",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A198",
    offset: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A198",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A097",
    offset: 0.648
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A097",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F96",
    offset: 0.664
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F96",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79E95",
    offset: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69E95",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69D95",
    offset: 0.695
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69D94",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69C94",
    offset: 0.711
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69C93",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69B93",
    offset: 0.727
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69B93",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69A92",
    offset: 0.742
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69992",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69991",
    offset: 0.758
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69891",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59891",
    offset: 0.773
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59790",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59790",
    offset: 0.789
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5968F",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5968F",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5968F",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5968F",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 300 509 L 375 509 L 375 553 L 300 553 Z M 300 509"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "az"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 372.84375 512.984375 C 372.84375 512.984375 377.25 511.734375 372.84375 524.519531 C 368.4375 537.308594 364.910156 543.921875 365.351562 549.210938 C 365.792969 554.503906 349.925781 552.738281 340.671875 549.210938 C 331.414062 545.683594 313.050781 549.210938 305.707031 547.890625 C 298.359375 546.566406 297.480469 533.042969 309.378906 532.75 C 321.277344 532.457031 356.976562 509.75 356.976562 509.75 Z M 372.84375 512.984375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 83.273,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 377.196,
    x2: 83.273,
    gradientUnits: "userSpaceOnUse",
    y2: 413.957,
    id: "aA"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4976",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4975",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594975",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594874",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584874",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574773",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574772",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564672",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564671",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554670",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554570",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54456F",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54446E",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446E",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52446D",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52436D",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51436C",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51426B",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426B",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426A",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4067",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4067",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E65",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E64",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3D64",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3D63",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493D62",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C62",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C61",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463B5F",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463A5F",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#453A5E",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45395D",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44395D",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43395C",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43385B",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42385B",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42375A",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413759",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413759",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3557",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3556",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3556",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3455",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3454",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3354",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3353",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3252",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3252",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3251",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393150",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 306 448 L 332 448 L 332 472 L 306 472 Z M 306 448"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 316.125 448.585938 L 306.503906 462.027344 C 306.503906 462.027344 309.886719 474.355469 320.402344 470.335938 C 330.921875 466.320312 331.882812 459.972656 331.882812 459.972656 Z M 316.125 448.585938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 68.192,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 326.951,
    x2: 68.192,
    gradientUnits: "userSpaceOnUse",
    y2: 348.118,
    id: "aD"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCB9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCB8",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCBB8",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCAB7",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC9B6",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC8B6",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC7B5",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC6B4",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC5B3",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC4B3",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC3B2",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC2B1",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC1B0",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC0B0",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBFAF",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBEAE",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBDAD",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBCAD",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBBAC",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBAAB",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB9AA",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB8AA",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB7A9",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB6A8",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB5A7",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB4A7",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB3A6",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2A5",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB1A4",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB0A4",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB0A3",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAFA2",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AEA1",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ADA1",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ACA0",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AB9F",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA9E",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A99E",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A89D",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A79C",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A69B",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A59B",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A49A",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A399",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A298",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A198",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A097",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F96",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79E95",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69D95",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69C94",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69B93",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69A92",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69992",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59891",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59790",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5968F",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5968F",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 242 462 L 322 462 L 322 504 L 242 504 Z M 242 462"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 320.402344 470.335938 C 320.402344 470.335938 324.976562 470.617188 316.585938 481.222656 C 308.191406 491.828125 302.675781 496.898438 301.339844 502.035156 C 300.003906 507.175781 285.617188 500.253906 278.054688 493.859375 C 270.488281 487.464844 251.992188 484.710938 245.5 481.027344 C 239.007812 477.347656 242.652344 464.296875 253.976562 467.960938 C 265.304688 471.625 306.503906 462.027344 306.503906 462.027344 Z M 320.402344 470.335938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 37.604,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 337.994,
    x2: 37.604,
    gradientUnits: "userSpaceOnUse",
    y2: 375.079,
    id: "aG"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4976",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4975",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594875",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584874",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584873",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574773",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574772",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564671",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564671",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554670",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544570",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54456F",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446E",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446E",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52436D",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52436C",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51436C",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426B",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426A",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F416A",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4067",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E65",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E64",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3E64",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3D63",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493D62",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C62",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C61",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463B5F",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463A5E",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#453A5E",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44395D",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44395C",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43385C",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43385B",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42385A",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42375A",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413759",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3557",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3556",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3556",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3455",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3455",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3354",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3353",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3353",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3252",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3251",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393150",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393150",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 315 328 L 403 328 L 403 461 L 315 461 Z M 315 328"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 392.984375 329.09375 C 392.984375 329.09375 378.792969 323.042969 353.671875 375.0625 C 328.550781 427.082031 315.988281 448.910156 315.988281 448.910156 L 331.195312 460.8125 C 331.195312 460.8125 386.066406 402.394531 391.355469 388.726562 C 396.644531 375.058594 412.464844 336.257812 392.984375 329.09375 Z M 392.984375 329.09375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 101.079,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 223.825,
    x2: 101.079,
    gradientUnits: "userSpaceOnUse",
    y2: 336.995,
    id: "aJ"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4976",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594975",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594875",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584874",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584873",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574773",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574772",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564671",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564671",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554670",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554570",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54456F",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446E",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446E",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52446D",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52436C",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51436C",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51426B",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426A",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50416A",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4169",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4067",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D3F67",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F65",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E65",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E64",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3D63",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493D63",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493D62",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C62",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C61",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463B5F",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463A5E",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#453A5E",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44395D",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44395C",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43395C",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43385B",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42385B",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42375A",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413759",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413659",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3657",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3557",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3556",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3455",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3455",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3454",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3354",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3353",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3252",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3252",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3251",
    offset: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393150",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 361 317 L 564 317 L 564 501 L 361 501 Z M 361 317"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 563.140625 323.449219 C 563.140625 323.449219 554.023438 375.050781 535.472656 375.058594 C 516.921875 375.0625 421.214844 368.222656 421.214844 368.222656 C 422.128906 371.722656 422.746094 375.269531 423.0625 378.871094 C 423.378906 382.472656 423.390625 386.074219 423.101562 389.675781 C 422.808594 393.28125 422.21875 396.835938 421.328125 400.335938 C 420.441406 403.839844 419.261719 407.246094 417.796875 410.550781 C 407.882812 432.375 383.421875 500.347656 383.421875 500.347656 L 361.605469 493.878906 C 361.605469 493.878906 387.386719 334.222656 395.320312 323.449219 C 403.253906 312.671875 517.621094 320.609375 517.621094 320.609375 Z M 563.140625 323.449219"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 185.852,
    gradientTransform: "matrix(1.2169 0 0 1.21735 236.21 50.57)",
    y1: 215.304,
    x2: 185.852,
    gradientUnits: "userSpaceOnUse",
    y2: 369.469,
    id: "aM"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4A77",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4976",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4975",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594875",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584874",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584873",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574773",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574772",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564672",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564671",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554670",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554570",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54456F",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54446E",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53446E",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52446D",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52436D",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51436C",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51426B",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426B",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50426A",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4169",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4068",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4067",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F66",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E65",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3E64",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3E64",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3D63",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493D63",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493C62",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C61",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483C61",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473B60",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463B5F",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463A5F",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#453A5E",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#453A5E",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44395D",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44395C",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43385C",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43385B",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42385A",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42375A",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413759",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403659",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403658",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3657",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3557",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3556",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3455",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3455",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3454",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3354",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3353",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3252",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3252",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3251",
    offset: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393150",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 587.824219 387.605469 L 587.824219 470.273438 L 775.574219 470.273438 L 775.574219 387.605469 Z M 587.824219 387.605469"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 301.570312 373.9375 L 301.570312 484.160156 L 789.898438 484.160156 L 789.898438 373.9375 Z M 301.570312 373.9375",
    style: {
      fillRule: "nonzero",
      paintOrder: "fill",
      fill: "rgba(60, 131, 238, 0.92)"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5DAC6",
    d: "M 514.390625 382.945312 L 514.390625 475.15625 C 514.390625 479.207031 518.320312 482.628906 523.699219 483.78125 L 523.699219 484.160156 L 509.117188 484.160156 C 501.835938 484.160156 495.929688 480.125 495.929688 475.15625 L 495.929688 382.945312 C 495.929688 377.976562 501.835938 373.941406 509.117188 373.941406 L 523.699219 373.941406 L 523.699219 374.339844 C 518.320312 375.472656 514.390625 378.894531 514.390625 382.945312 Z M 514.390625 382.945312"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5DAC6",
    d: "M 550.382812 382.945312 L 550.382812 475.15625 C 550.382812 479.207031 554.3125 482.628906 559.691406 483.78125 L 559.691406 484.160156 L 545.109375 484.160156 C 537.828125 484.160156 531.921875 480.125 531.921875 475.15625 L 531.921875 382.945312 C 531.921875 377.976562 537.828125 373.941406 545.109375 373.941406 L 559.691406 373.941406 L 559.691406 374.339844 C 554.3125 375.472656 550.382812 378.894531 550.382812 382.945312 Z M 550.382812 382.945312"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M 300.515625 496.296875 L 300.515625 578.964844 L 488.265625 578.964844 L 488.265625 496.296875 Z M 300.515625 496.296875"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 286.191406 482.628906 L 286.191406 592.78125 L 774.519531 592.78125 L 774.519531 482.628906 Z M 286.191406 482.628906",
    style: {
      fill: "rgb(40, 123, 247)"
    }
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5C6C6",
    d: "M 561.699219 491.636719 L 561.699219 583.847656 C 561.699219 587.898438 557.773438 591.320312 552.390625 592.472656 L 552.390625 592.847656 L 566.976562 592.847656 C 574.253906 592.847656 580.160156 588.816406 580.160156 583.847656 L 580.160156 491.636719 C 580.160156 486.667969 574.253906 482.632812 566.976562 482.632812 L 552.390625 482.632812 L 552.390625 483.03125 C 557.773438 484.164062 561.699219 487.585938 561.699219 491.636719 Z M 561.699219 491.636719"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5C6C6",
    d: "M 525.707031 491.636719 L 525.707031 583.847656 C 525.707031 587.898438 521.777344 591.320312 516.398438 592.472656 L 516.398438 592.847656 L 530.980469 592.847656 C 538.261719 592.847656 544.167969 588.816406 544.167969 583.847656 L 544.167969 491.636719 C 544.167969 486.667969 538.261719 482.632812 530.980469 482.632812 L 516.398438 482.632812 L 516.398438 483.03125 C 521.777344 484.164062 525.707031 487.585938 525.707031 491.636719 Z M 525.707031 491.636719"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M 727.058594 258.746094 L 727.058594 373.714844 L 752.71875 373.714844 L 752.71875 258.746094 Z M 727.058594 258.746094"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#393150",
    d: "M 737.191406 303.085938 C 734.453125 289.675781 730.242188 280.277344 727.058594 275.867188 L 727.058594 258.746094 C 730.699219 263.183594 733.875 267.9375 736.578125 273.003906 C 737.945312 282.796875 738.703125 293.996094 737.191406 303.085938 Z M 737.191406 303.085938",
    fillOpacity: 0.498
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M 629.210938 245.175781 L 629.210938 373.714844 L 727.058594 373.714844 L 727.058594 245.175781 Z M 629.210938 245.175781"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M 645.53125 245.175781 L 645.53125 300.621094 L 714.335938 300.621094 L 714.335938 245.175781 Z M 645.53125 245.175781"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M 672.402344 281.523438 L 672.402344 291.886719 L 682.761719 291.886719 L 682.761719 281.523438 Z M 672.402344 281.523438"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M 629.210938 323.226562 L 629.210938 373.714844 L 727.058594 373.714844 L 727.058594 323.226562 Z M 629.210938 323.226562"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M 707.222656 319.589844 L 707.222656 333.148438 L 712.839844 333.148438 L 712.839844 319.589844 Z M 707.222656 319.589844"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M 649.632812 319.589844 L 649.632812 333.148438 L 655.25 333.148438 L 655.25 319.589844 Z M 649.632812 319.589844"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#G)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M 468.085938 145.378906 L 468.085938 304.449219 L 506.386719 304.449219 L 506.386719 145.378906 Z M 468.085938 145.378906"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#J)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M 465.066406 138.640625 L 465.066406 165.632812 L 496.25 165.632812 L 496.25 138.640625 Z M 465.066406 138.640625"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#L)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#M)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M 474.371094 135.496094 L 474.371094 324.574219 L 553.394531 324.574219 L 553.394531 135.496094 Z M 474.371094 135.496094"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#393150",
    d: "M 496.246094 226.878906 C 496.246094 226.878906 496.429688 268.351562 486.605469 278.464844 C 483.347656 281.820312 479.980469 284.554688 476.851562 287.46875 C 475.757812 304.492188 475.09375 324.574219 475.09375 324.574219 C 475.09375 324.574219 495.28125 323.496094 513.652344 322.730469 Z M 496.246094 226.878906",
    fillOpacity: 0.2
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#O)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#P)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M 418.460938 295.203125 L 418.460938 310.027344 L 465.066406 310.027344 L 465.066406 295.203125 Z M 418.460938 295.203125"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#393150",
    d: "M 461.3125 295.203125 C 461.3125 295.203125 460.273438 295.269531 458.648438 295.417969 C 457.257812 300.191406 456.65625 305.058594 456.839844 310.027344 L 465.066406 310.027344 Z M 461.3125 295.203125",
    fillOpacity: 0.2
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#R)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#S)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M 459.445312 292.128906 L 459.445312 312.339844 L 474.730469 312.339844 L 474.730469 292.128906 Z M 459.445312 292.128906"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#U)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#V)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M 365.878906 244.789062 L 365.878906 315.585938 L 400.316406 315.585938 L 400.316406 244.789062 Z M 365.878906 244.789062"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#X)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M 391.355469 310.027344 L 391.355469 317.984375 L 465.066406 317.984375 L 465.066406 310.027344 Z M 391.355469 310.027344"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M 424.851562 55.851562 L 424.851562 118.847656 L 512.113281 118.847656 L 512.113281 55.851562 Z M 424.851562 55.851562"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M 475.09375 109.640625 L 475.09375 170.484375 L 504.613281 170.484375 L 504.613281 109.640625 Z M 475.09375 109.640625"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#393150",
    d: "M 479.148438 141.082031 L 481.433594 148.613281 C 483.664062 148.066406 485.597656 146.992188 487.234375 145.378906 C 495.808594 137.820312 501.4375 117.476562 501.4375 117.476562 Z M 479.148438 141.082031",
    fillOpacity: 0.2
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ah)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "M 454.007812 91.097656 L 454.007812 148.976562 L 505.058594 148.976562 L 505.058594 91.097656 Z M 454.007812 91.097656"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aj)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ak)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M 464.890625 107.613281 L 464.425781 115.960938 L 469.664062 115.703125 L 470.125 107.355469 Z M 464.890625 107.613281"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F46060",
    d: "M 479.167969 134.347656 C 478.9375 134.347656 478.734375 134.269531 478.5625 134.113281 C 478.390625 133.957031 478.296875 133.765625 478.273438 133.535156 C 478.25 133.304688 478.308594 133.09375 478.449219 132.910156 C 478.585938 132.722656 478.769531 132.609375 478.996094 132.5625 C 479.394531 132.484375 482.746094 131.65625 482.027344 127.085938 C 481.996094 126.84375 482.054688 126.625 482.199219 126.429688 C 482.347656 126.234375 482.539062 126.117188 482.78125 126.078125 C 483.023438 126.039062 483.242188 126.089844 483.441406 126.234375 C 483.640625 126.375 483.761719 126.5625 483.804688 126.804688 C 484.808594 133.210938 479.394531 134.320312 479.339844 134.332031 C 479.28125 134.34375 479.226562 134.347656 479.167969 134.347656 Z M 479.167969 134.347656"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 459.914062 106.15625 C 459.539062 106.15625 459.273438 105.988281 459.105469 105.652344 C 458.941406 105.3125 458.976562 104.996094 459.207031 104.703125 C 459.773438 104.019531 460.433594 103.441406 461.183594 102.96875 C 461.933594 102.496094 462.742188 102.152344 463.601562 101.9375 C 464.464844 101.722656 465.339844 101.652344 466.222656 101.71875 C 467.109375 101.785156 467.960938 101.988281 468.78125 102.328125 C 468.894531 102.367188 468.996094 102.429688 469.085938 102.511719 C 469.175781 102.597656 469.246094 102.695312 469.296875 102.804688 C 469.347656 102.917969 469.375 103.035156 469.375 103.15625 C 469.378906 103.277344 469.359375 103.394531 469.3125 103.507812 C 469.265625 103.621094 469.203125 103.722656 469.113281 103.808594 C 469.027344 103.894531 468.929688 103.960938 468.816406 104.007812 C 468.703125 104.054688 468.585938 104.078125 468.464844 104.074219 C 468.339844 104.074219 468.222656 104.046875 468.113281 104 C 467.472656 103.730469 466.808594 103.570312 466.117188 103.515625 C 465.425781 103.460938 464.742188 103.515625 464.070312 103.679688 C 463.394531 103.84375 462.765625 104.105469 462.175781 104.472656 C 461.585938 104.835938 461.070312 105.285156 460.621094 105.816406 C 460.441406 106.042969 460.207031 106.15625 459.914062 106.15625 Z M 459.914062 106.15625"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#393150",
    d: "M 423.417969 310.027344 C 423.417969 310.027344 429.035156 305.910156 433.003906 305.582031 C 435.773438 305.203125 438.308594 304.214844 440.605469 302.613281 C 440.605469 302.613281 433.664062 301.238281 423.417969 310.027344 Z M 423.417969 310.027344",
    fillOpacity: 0.2
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#am)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#an)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ao)",
    d: "M 486.28125 137.691406 L 486.28125 328.832031 L 596.507812 328.832031 L 596.507812 137.691406 Z M 486.28125 137.691406"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#393150",
    d: "M 595.734375 306.09375 C 595.628906 307.191406 595.378906 308.25 594.976562 309.277344 C 594.578125 310.304688 594.046875 311.257812 593.382812 312.136719 C 592.71875 313.015625 591.945312 313.785156 591.070312 314.449219 C 590.191406 315.117188 589.238281 315.648438 588.214844 316.050781 C 576.730469 320.566406 551.085938 328.832031 524.019531 325.230469 C 492.492188 321.054688 492.722656 316.554688 492.8125 310.59375 C 496.339844 306.8125 503.488281 303.070312 517.613281 301.519531 C 545.453125 298.460938 567.265625 272.121094 576.480469 255.179688 C 579.144531 260.800781 582.371094 266.074219 586.160156 271.003906 C 595.953125 283.410156 596.507812 297.703125 595.734375 306.09375 Z M 595.734375 306.09375",
    fillOpacity: 0.2
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ap)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar)",
    d: "M 486.28125 137.691406 L 486.28125 177.820312 L 513.652344 177.820312 L 513.652344 137.691406 Z M 486.28125 137.691406"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#at)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#au)",
    d: "M 466.71875 168.921875 L 466.71875 315.316406 L 580.425781 315.316406 L 580.425781 168.921875 Z M 466.71875 168.921875"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#av)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aw)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ax)",
    d: "M 356.976562 493.878906 L 356.976562 524.800781 L 380.242188 524.800781 L 380.242188 493.878906 Z M 356.976562 493.878906"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ay)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#az)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aA)",
    d: "M 297.480469 509.75 L 297.480469 554.503906 L 377.25 554.503906 L 377.25 509.75 Z M 297.480469 509.75"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.2169, 0, 0, 1.21735, 236.210007, 50.57)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 88.105483 386.310741 L 91.636487 389.840423",
    stroke: "#FFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.2169, 0, 0, 1.21735, 236.210007, 50.57)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 81.585966 389.840423 L 85.659461 394.77556",
    stroke: "#FFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.2169, 0, 0, 1.21735, 236.210007, 50.57)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 74.523958 392.757224 L 77.239621 397.073063",
    stroke: "#FFF"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aB)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aD)",
    d: "M 306.503906 448.585938 L 306.503906 474.355469 L 331.882812 474.355469 L 331.882812 448.585938 Z M 306.503906 448.585938"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aE)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aF)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aG)",
    d: "M 239.007812 462.027344 L 239.007812 507.175781 L 324.976562 507.175781 L 324.976562 462.027344 Z M 239.007812 462.027344"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.2169, 0, 0, 1.21735, 236.210007, 50.57)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 44.751175 343.110638 L 47.466838 347.301333",
    stroke: "#FFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.2169, 0, 0, 1.21735, 236.210007, 50.57)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 37.637808 345.202777 L 40.594221 350.879148",
    stroke: "#FFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.2169, 0, 0, 1.21735, 236.210007, 50.57)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 30.123189 346.582562 L 31.879061 351.370095",
    stroke: "#FFF"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aH)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aJ)",
    d: "M 315.988281 323.042969 L 315.988281 460.8125 L 412.464844 460.8125 L 412.464844 323.042969 Z M 315.988281 323.042969"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#393150",
    d: "M 358.050781 431.296875 C 372.792969 414.625 388.632812 395.757812 391.355469 388.726562 C 396.21875 376.148438 409.984375 342.316406 396.976562 331.40625 C 391.269531 337.9375 383.875 350.796875 376.003906 376.101562 C 368.433594 400.441406 362.417969 418.597656 358.050781 431.296875 Z M 358.050781 431.296875",
    fillOpacity: 0.298
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aK)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aL)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aM)",
    d: "M 361.605469 312.671875 L 361.605469 500.347656 L 563.140625 500.347656 L 563.140625 312.671875 Z M 361.605469 312.671875"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#393150",
    d: "M 486.105469 318.878906 C 493.496094 322.683594 507.539062 324.074219 524.019531 325.230469 C 549.589844 327.027344 531.507812 347.90625 517.621094 357.992188 C 503.738281 368.078125 421.667969 358.964844 415.152344 345.703125 C 408.640625 332.4375 403.410156 347.246094 407.21875 357.164062 C 411.03125 367.085938 421.214844 368.222656 421.214844 368.222656 C 421.214844 368.222656 516.921875 375.0625 535.472656 375.058594 C 554.023438 375.050781 563.140625 323.449219 563.140625 323.449219 L 517.621094 320.609375 C 517.621094 320.609375 504.136719 319.671875 486.105469 318.878906 Z M 486.105469 318.878906",
    fillOpacity: 0.298
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.2169, 0, 0, 1.21735, 236.210007, 50.57)",
    fill: "none",
    d: "M 100.842777 401.507627 C 100.842777 401.915145 100.765737 402.30341 100.611657 402.675631 C 100.454367 403.051061 100.236087 403.381568 99.950396 403.667151 C 99.664706 403.952734 99.334076 404.174142 98.958505 404.328164 C 98.586145 404.482187 98.197734 404.559198 97.793274 404.559198 C 97.388813 404.559198 96.997193 404.482187 96.624833 404.328164 C 96.249262 404.174142 95.921842 403.952734 95.636151 403.667151 C 95.347251 403.381568 95.128971 403.051061 94.971681 402.675631 C 94.817601 402.30341 94.740561 401.915145 94.740561 401.507627 C 94.740561 401.103318 94.817601 400.715053 94.971681 400.342832 C 95.128971 399.967402 95.347251 399.636896 95.636151 399.351312 C 95.921842 399.065729 96.249262 398.844322 96.624833 398.690299 C 96.997193 398.536277 97.388813 398.459265 97.793274 398.459265 C 98.197734 398.459265 98.586145 398.536277 98.958505 398.690299 C 99.334076 398.844322 99.664706 399.065729 99.950396 399.351312 C 100.236087 399.636896 100.454367 399.967402 100.611657 400.342832 C 100.765737 400.715053 100.842777 401.103318 100.842777 401.507627 Z M 100.842777 401.507627",
    stroke: "#FFF",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.a45b1763de4c9b9858b7a6d63c37a53e.svg";
export { ForwardRef as ReactComponent };